import React from 'react';
import { Activity, CheckCircle, XCircle, Clock, Target } from 'lucide-react';
import { TriggerLogsSummary as TriggerLogsSummaryType } from '../../../hooks/queries/useTriggerLogs';

interface TriggerLogsSummaryProps {
  summary: TriggerLogsSummaryType;
}

export function TriggerLogsSummary({ summary }: TriggerLogsSummaryProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {/* Total Executions */}
      <div className="bg-white p-4 rounded-lg border border-gray-200">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg">
            <Activity className="h-4 w-4 text-blue-600" />
          </div>
          <div>
            <p className="text-sm font-medium text-gray-600">Total Executions</p>
            <p className="text-lg font-bold text-gray-900">{summary.totalExecutions}</p>
          </div>
        </div>
      </div>

      {/* Success Rate */}
      <div className="bg-white p-4 rounded-lg border border-gray-200">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-green-100 rounded-lg">
            <CheckCircle className="h-4 w-4 text-green-600" />
          </div>
          <div>
            <p className="text-sm font-medium text-gray-600">Success Rate</p>
            <div className="flex items-center gap-2">
              <p className="text-lg font-bold text-gray-900">{Math.round(summary.successRate)}%</p>
              <span className={`text-xs px-2 py-1 rounded-full ${
                summary.successRate >= 90 
                  ? 'bg-green-100 text-green-800' 
                  : summary.successRate >= 70 
                    ? 'bg-yellow-100 text-yellow-800' 
                    : 'bg-red-100 text-red-800'
              }`}>
                {summary.successfulExecutions}/{summary.totalExecutions}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Average Response Time */}
      <div className="bg-white p-4 rounded-lg border border-gray-200">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-yellow-100 rounded-lg">
            <Clock className="h-4 w-4 text-yellow-600" />
          </div>
          <div>
            <p className="text-sm font-medium text-gray-600">Avg Response Time</p>
            <p className="text-lg font-bold text-gray-900">
              {summary.averageResponseTime > 0 ? `${Math.round(summary.averageResponseTime)}ms` : 'N/A'}
            </p>
          </div>
        </div>
      </div>

      {/* Active Triggers */}
      <div className="bg-white p-4 rounded-lg border border-gray-200">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-purple-100 rounded-lg">
            <Target className="h-4 w-4 text-purple-600" />
          </div>
          <div>
            <p className="text-sm font-medium text-gray-600">Active Triggers</p>
            <p className="text-lg font-bold text-gray-900">{summary.activeTriggers}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
